import React from 'react';
import GatsbyLink from 'gatsby-link';

import Button from '@marvelapp/marvel-ui/button';
import Cta from 'marketing-website/components/modules/Cta/CtaDefault';
import MarvelLink from '@marvelapp/marvel-ui/link';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import assets from 'marketing-website/configs/pages/sketch/assets';
import Image from 'marketing-website/components/modules/Image';
import Page from 'marketing-website/components/modules/Page';
import Whitespace from 'marketing-website/components/commons/Whitespace';

import FeaturesBlockList from '../sketch/FeaturesBlockList';
import ImageBlock from '../sketch/ImageBlock';

import styles from '../sketch/style/general.module.css';

const buttons = [
  {
    text: 'Sign up free',
    link: '/signup/',
    styles: {
      shape: 'rounded',
      size: 'large',
      minWidth: 160,
    },
  },
  {
    text: 'Explore Plans',
    link: '/pricing/',
    styles: {
      shape: 'rounded',
      size: 'large',
      kind: 'ghost',
      minWidth: 160,
    },
  },
];

export default function Sketch() {
  return (
    <Page
      title="Sketch prototyping in Marvel: sync artboards, hotspots and more"
      meta={[
        {
          name: 'description',
          content: 'Prototype in Sketch or Marvel',
        },
        {
          name: 'keywords',
          content: 'sketch, prototyping',
        },
      ]}
      header
      footer
    >
      <div className="overflow-hidden">
        <div className={styles.wrap}>
          <Spacing size="xl" position="bottom">
            <Image {...assets.illustration} hasShadow={false} maxWidth={860} />
          </Spacing>
          <MaxWidth value={600}>
            <h1 className={styles.heading}>Your Sketch workflow, reimagined</h1>
            <Spacing size="l" type="padding" position="bottom">
              <Paragraph size="xxl" className={styles.subheading}>
                Seamlessly import prototypes and sync artboards from Sketch into
                Marvel, then handoff code and help bring teams together.
              </Paragraph>
            </Spacing>
          </MaxWidth>
          <div className={styles.buttons}>
            <div className={styles.margin}>
              <MarvelLink
                url="https://storage.googleapis.com/sketch-plugin/Marvel.zip"
                type="opaqueReversed"
                hasUnderline
                target="_blank"
              >
                <Button size="extraLarge" shape="rounded" minWidth={170}>
                  Download Sketch Plugin
                </Button>
              </MarvelLink>
            </div>
          </div>
          <Whitespace size="m" sizeM="xl" />

          <ImageBlock
            isRightAligned
            artwork={assets.prototyping}
            title="Import Sketch prototypes into Marvel"
            copy="Send your hotspots to Marvel and create prototypes that 
            update as and when you make changes in Sketch - no need to 
            reorganise or revisit. We speak Sketch's language, leaving 
            you with more time for problem solving."
          />

          <Whitespace size="s" sizeM="l" />
          <ImageBlock
            artwork={assets.collaborate}
            copy="Effortlessly sync artboards from Sketch to new or existing Marvel projects. Automated syncing means less manual work for you and your team and creates a centralised space for how your team collaborates."
            title="Design, sync, work together"
          />
          <Whitespace size="m" sizeM="l" />
          <FeaturesBlockList />
          <Whitespace size="m" sizeM="xl" />
          <ImageBlock
            isRightAligned
            artwork={assets.embed}
            title="Bring it to life in Marvel"
            copy={
              <span>
                Take your prototypes to the next level with a wider range of
                transitions, ability to embed video and link to URLs. Our
                library of integrations means it doesn’t have to stop there,
                create meaningful user tests with{' '}
                <GatsbyLink to="/integrations/maze">
                  <MarvelLink type="blue">Maze</MarvelLink>
                </GatsbyLink>{' '}
                or streamline product management with our{' '}
                <GatsbyLink to="/integrations/atlassian-jira">
                  <MarvelLink type="blue">JIRA integration </MarvelLink>
                </GatsbyLink>{' '}
                and more.{' '}
              </span>
            }
          />
        </div>
        <Whitespace size="l" sizeM="l" />
        <Cta
          bgColor="snow"
          buttons={buttons}
          maxWidth={700}
          title="Join millions of creatives using Marvel every day."
          size="xxxxl"
        />
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/sketch-prototyping/index.js